import React from 'react';
import { FEATURE_ID, ROUTE } from '../../../Common/constant';
import DataCaptureImage from "../../../assets/images/product/data-capture.png"
import RadarImage from "../../../assets/images/product/radar.png"
import SimulatorImage from "../../../assets/images/product/simulator.png"
import VRImage from "../../../assets/images/product/vr.png"
import IntegratedProductImage from '../../../assets/images/product/integrated-product-lines.png'
import { useNavigate } from 'react-router-dom';

const Product = () => {
    const navigate = useNavigate()
    const products = [
        {
            id: "simulator",
            title: 'Simulator',
            description: '',
            icon: SimulatorImage,
            url: ROUTE.PRODUCTS.DETAIL,
            data_aos_delay: '00ms',
        },
        {
            id: "vr-maintenance",
            title: 'VR Maintenance',
            description: '',
            icon: VRImage,
            url: ROUTE.PRODUCTS.DETAIL,
            data_aos_delay: '200ms',
        },
        {
            id: "fleet-management-system",
            title: 'Fleet Management System',
            description: '',
            icon: RadarImage,
            url: ROUTE.PRODUCTS.DETAIL,
            data_aos_delay: '600ms',
        },
        {
            id: "data-capture-and-analytics",
            title: 'Data Capture & Analytics',
            description: '',
            icon: DataCaptureImage,
            url: ROUTE.PRODUCTS.DETAIL,
            data_aos_delay: '400ms',
        },
    ];

    const onNavigate = (data) => () => navigate(String(data.url).replace(":id", data.id))

    return (
        <section id={FEATURE_ID.PRODUCT} className="service__section p_relative see__pad">
            <div className="auto-container">
                <div className="service__data">
                    <div className="title__data">
                        <div className="title">
                            <h2>Explore Our Products</h2>
                        </div>
                    </div>

                    <div style={{ width: '100%', margin: '24px 0 86px' }}>
                        <img src={IntegratedProductImage} alt='integrated-product' style={{ objectFit: 'contain' }} />
                    </div>

                    <div className="product__block__wrapper">
                        {products.map((item) => (
                            <div className="wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={item.id}>
                                <button className="product__block" onClick={onNavigate(item)}>
                                    <div className="product__icon">
                                        <img src={item.icon} alt={item.icon} />
                                    </div>
                                    <div className="product__text">
                                        <h4>{item.title}</h4>
                                    </div>
                                </button>
                            </div>
                        ))}
                    </div>
                    {/* <div className="row">
                        {products.map((item) => (
                            <div className="col-lg-3 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={item.id}>
                                <div className="service__block">
                                    <div className="service__icon">
                                        <i className={item.icon}></i>
                                        <i>{item.title}</i>
                                    </div>
                                    <div className="service__text">
                                        <h4><Link to={item.href}>{item.title}</Link></h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Product;